module.exports = __webpack_public_path__ + "img/map-marker.dc0d0c0f.svg";